export const LOCATIONS = [
  {
    id: "loc-1",
    slug: "sediul-central",
    name_ro: "Sediul Central",
    name_en: "Headquarters",
    address_ro: "Str. Poporului Nr. 23, Constanta",
    address_en: "Poporului Street No. 23, Constanta",
    phone: "0241.693.219 / 0722.641.633",
    hours_ro: "L-V 08:30-20 | Sambata 08:30-18 | Duminica 09-15",
    hours_en: "Mon-Fri 08:30-20 | Sat 08:30-18 | Sun 09-15",
    image_url: "/pozaSediuCentral.jpeg",
    maps_query: "Corsa Exchange, Strada Poporului 23, Constanța, Romania",
    is_main: true,
    order: 1,
    lat: 44.18957,
    lng: 28.63625,
    city: "constanta",
  },
  {
    id: "loc-2",
    slug: "filiala-1-city-park-mall",
    name_ro: "Filiala 1 City Park Mall",
    name_en: "City Park Mall - Branch 1",
    address_ro: "City Park Mall, intrare Carrefour, nivel -1, Constanta",
    address_en: "City Park Mall, Carrefour entrance, level -1, Constanta",
    phone: "0341.463.199",
    hours_ro: "L-D 10:00-22:00",
    hours_en: "Mon-Sun 10:00-22:00",
    image_url: "/city1.jpeg",
    is_main: false,
    order: 2,
    lat: 44.20395,
    lng: 28.6313,
    city: "constanta",
  },
  {
    id: "loc-3",
    slug: "filiala-2-city-park-mall",
    name_ro: "Filiala 2 City Park Mall",
    name_en: "City Park Mall - Branch 2",
    address_ro: "City Park Mall, nivel 0, zona lifturi, Constanta",
    address_en: "City Park Mall, level 0, elevators area, Constanta",
    phone: "0341.452.926",
    hours_ro: "L-D 10:00-22:00",
    hours_en: "Mon-Sun 10:00-22:00",
    image_url: "/city2.jpeg",
    is_main: false,
    order: 3,
    lat: 44.2034,
    lng: 28.6325,
    city: "constanta",
  },
  {
    id: "loc-4",
    slug: "filiala-1-vivo",
    name_ro: "Filiala 1 Vivo",
    name_en: "Vivo - Branch 1",
    address_ro: "Vivo! Constanta, Bulevardul Aurel Vlaicu 220, Constanta",
    address_en: "Vivo! Constanta, Aurel Vlaicu Boulevard 220, Constanta",
    phone: "0341.463.115",
    hours_ro: "L-D 10:00-22:00",
    hours_en: "Mon-Sun 10:00-22:00",
    image_url: "/maritimo1.jpeg",
    maps_query: "Vivo! Constanța, Bulevardul Aurel Vlaicu 220, Constanța",
    is_main: false,
    order: 4,
    lat: 44.19875,
    lng: 28.6093,
    city: "constanta",
  },
  {
    id: "loc-5",
    slug: "filiala-2-vivo",
    name_ro: "Filiala 2 Vivo",
    name_en: "Vivo - Branch 2",
    address_ro: "Vivo! Constanta, Bulevardul Aurel Vlaicu 220, Constanta",
    address_en: "Vivo! Constanta, Aurel Vlaicu Boulevard 220, Constanta",
    phone: "0341.177.268",
    hours_ro: "L-D 10:00-22:00",
    hours_en: "Mon-Sun 10:00-22:00",
    image_url: "/vivo2.jpeg",
    maps_query: "Vivo! Constanța, Bulevardul Aurel Vlaicu 220, Constanța",
    is_main: false,
    order: 5,
    lat: 44.19835,
    lng: 28.6103,
    city: "constanta",
  },
  {
    id: "loc-6",
    slug: "filiala-eden",
    name_ro: "Filiala Eden",
    name_en: "Eden Branch",
    address_ro: "Strada Soveja nr. 77, Constanta",
    address_en: "Soveja Street no. 77, Constanta",
    phone: "0341.177.263",
    hours_ro: "L-V 08:30-20 | Sambata 08:30-17 | Duminica 09-15",
    hours_en: "Mon-Fri 08:30-20 | Sat 08:30-17 | Sun 09-15",
    image_url: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800",
    is_main: false,
    order: 6,
    lat: 44.19041,
    lng: 28.62507,
    city: "constanta",
  },
  {
    id: "loc-7",
    slug: "filiala-kaufland-constanta-icil",
    name_ro: "Filiala Kaufland Constanta - ICIL",
    name_en: "Kaufland Constanta ICIL",
    address_ro: "Bulevardul 1 Decembrie nr. 21, Constanta",
    address_en: "1 Decembrie Boulevard no. 21, Constanta",
    phone: "",
    hours_ro: "L-S 08:30-21 | Duminica 09-20",
    hours_en: "Mon-Sat 08:30-21 | Sun 09-20",
    image_url: "/kauflandIcil.jpeg",
    is_main: false,
    order: 7,
    lat: 44.17291,
    lng: 28.63522,
    city: "constanta",
  },
  {
    id: "loc-8",
    slug: "filiala-kaufland-constanta-coiciu",
    name_ro: "Filiala Kaufland Constanta - Coiciu",
    name_en: "Kaufland Constanta Coiciu",
    address_ro: "Strada Ion Roata nr. 3, Constanta",
    address_en: "Ion Roata Street no. 3, Constanta",
    phone: "",
    hours_ro: "L-S 09:00-21 | Duminica 09-18",
    hours_en: "Mon-Sat 09:00-21 | Sun 09-18",
    image_url: "/kauflandCoiciu.jpeg",
    is_main: false,
    order: 8,
    lat: 44.17832,
    lng: 28.62344,
    city: "constanta",
  },
  {
    id: "loc-9",
    slug: "filiala-navodari",
    name_ro: "Filiala Navodari",
    name_en: "Navodari Branch",
    address_ro: "Orasul Navodari, Strada Constantei nr. 15",
    address_en: "Navodari, Constantei Street no. 15",
    phone: "0341.430.339",
    hours_ro: "L-S 09:00-21 | Duminica 09-18",
    hours_en: "Mon-Sat 09:00-21 | Sun 09-18",
    image_url: "/navodari.jpeg",
    is_main: false,
    order: 9,
    lat: 44.31916,
    lng: 28.60545,
    city: "navodari",
  },
  {
    id: "loc-10",
    slug: "filiala-kaufland-navodari",
    name_ro: "Filiala Kaufland Navodari",
    name_en: "Kaufland Navodari",
    address_ro: "Strada Constantei nr. 26, Navodari",
    address_en: "Constantei Street no. 26, Navodari",
    phone: "0341.413.212",
    hours_ro: "L-S 09:00-21 | Duminica 09-18",
    hours_en: "Mon-Sat 09:00-21 | Sun 09-18",
    image_url: "/kauflandNavodari.jpeg",
    is_main: false,
    order: 10,
    lat: 44.31925,
    lng: 28.60355,
    city: "navodari",
  },
  {
    id: "loc-11",
    slug: "filiala-kaufland-mangalia",
    name_ro: "Filiala Kaufland Mangalia",
    name_en: "Kaufland Mangalia",
    address_ro: "Soseaua Gral. Alexandru Vartejanu nr. 1A, Mangalia",
    address_en: "Gral. Alexandru Vartejanu Avenue no. 1A, Mangalia",
    phone: "",
    hours_ro: "L-S 09:00-21 | Duminica 09-18",
    hours_en: "Mon-Sat 09:00-21 | Sun 09-18",
    image_url: "/KauflandVatajeanu.jpeg",
    is_main: false,
    order: 11,
    lat: 43.81525,
    lng: 28.57144,
    city: "mangalia",
  },
  {
    id: "loc-12",
    slug: "filiala-kaufland-mangalia-lavrion",
    name_ro: "Filiala Kaufland Mangalia - Lavrion",
    name_en: "Kaufland Mangalia - Lavrion",
    address_ro: "Strada Lavrion nr. 30A, Mangalia",
    address_en: "Lavrion Street no. 30A, Mangalia",
    phone: "",
    hours_ro: "L-S 09:00-21:00 | Duminica 09-18",
    hours_en: "Mon-Sat 09:00-21:00 | Sun 09-18",
    image_url: "/KauflandSaturn.jpeg",
    is_main: false,
    order: 12,
    lat: 43.83059,
    lng: 28.58062,
    city: "mangalia",
  },
];
